import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { IUser } from '../../../shared/models/interfaces/IUser';
import { AuthService } from '../../../shared/services/auth.service';

import { faCloudSunRain } from '@fortawesome/free-solid-svg-icons';
import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons';
import { ILoginPermissions } from '@shared/models/interfaces/ILoginResponse';
import { UserPermissions } from '@shared/helpers/userPermissions.helper';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.scss'],
})
export class HeaderComponent implements OnInit {
  private permissoesSubscription: Subscription;

  user: IUser;
  permissions: ILoginPermissions;
  userIcon: boolean;
  activeBurger: boolean = false;

  faCloudSunRain = faCloudSunRain;
  faTelegramPlane = faTelegramPlane;

  @Output() onLogin = new EventEmitter();
  @Output() onRequestPda = new EventEmitter();
  @Output() onWeather = new EventEmitter();
  @Output() onSettings = new EventEmitter();

  constructor(
    private authService: AuthService,
    private userPermissionService: UserPermissions,
    public router: Router
  ) {}

  ngOnInit() {
    this.user = this.authService.getCurrentUser();
    this.permissoesSubscription =
      this.userPermissionService.permissoes$.subscribe((permissoes) => {
        this.permissions = permissoes;
        console.log('Permissões atualizadas:', this.permissions);
      });

    this.screenWidth();
    this.authService.loginChanged().subscribe(() => this.onLoginChanged());
  }

  ngOnDestroy() {
    if (this.permissoesSubscription) {
      this.permissoesSubscription.unsubscribe();
    }
  }

  onLoginChanged() {
    this.user = this.authService.getCurrentUser();
  }

  screenWidth() {
    this.userIcon = window.innerWidth > 620 ? false : true;
  }

  logout() {
    this.router.navigateByUrl('/home');
    this.authService.logout();
  }

  handleLogin() {
    this.onLogin.emit();
  }

  handleRequestPda() {
    this.onRequestPda.emit();
  }

  handleWeather() {
    this.onWeather.emit();
  }

  handleSettings() {
    this.onSettings.emit();
  }

  handleClick(e) {
    if (e.target.classList.contains('active')) {
      this.activeBurger = false;
    }
  }

  hideMenuIfNeeds() {
    if (this.activeBurger) {
      this.activeBurger = false;
    }
  }
}
